import { PersoneelsdienstModel } from "../models/PersoneelsdienstModel";
import { PersoneelsdienstenModel } from "../models/PersoneelsdienstenModel";

// Groepeer diensten met hetzelfde nummer bij elkaar, en sorteer dat resultaat op nummer.
export function sortAndGroupData(input: PersoneelsdienstModel[]): PersoneelsdienstenModel[] {
  function groupAndConvertToPersoneelsDienstenModel(
    personeelsdiensten: PersoneelsdienstModel[],
  ): PersoneelsdienstenModel[] {
    const groups = new Map<string, PersoneelsdienstenModel>();
    personeelsdiensten.forEach((personeelsdienst) => {
      const dienstnummerStandplaatsKey =
        personeelsdienst.standplaatsDrglptNaam + personeelsdienst.dienstnummer;
      if (!groups.has(dienstnummerStandplaatsKey)) {
        const personeelsdienstenModel: PersoneelsdienstenModel = {
          id: personeelsdienst.standplaatsDrglptNaam + "." + personeelsdienst.dienstnummer,
          dienstnummer: personeelsdienst.dienstnummer,
          standplaatsDrglptNaam: personeelsdienst.standplaatsDrglptNaam,
          personeelsdiensten: [],
          displayRegels: 0,
        };
        groups.set(dienstnummerStandplaatsKey, personeelsdienstenModel);
      }
      groups.get(dienstnummerStandplaatsKey)?.personeelsdiensten.push(personeelsdienst);
    });

    groups.forEach((personeelsdienstenModel) => {
      personeelsdienstenModel.personeelsdiensten = [
        ...personeelsdienstenModel.personeelsdiensten,
      ].sort(
        (personeelsdienstModel1, personeelsdienstModel2) =>
          personeelsdienstModel1.starttijd.toUnixInteger() -
          personeelsdienstModel2.starttijd.toUnixInteger(),
      );
      personeelsdienstenModel.displayRegels =
        Math.max(
          ...personeelsdienstenModel.personeelsdiensten.flatMap((p) => p.displayRegels ?? 0),
        ) + 1;
    });

    return [...groups.values()];
  }

  const personeelDienstenModel = groupAndConvertToPersoneelsDienstenModel(input);

  personeelDienstenModel.sort((personeelsdienstenModel1, personeelsdienstenModel2) => {
    return personeelsdienstenModel1.dienstnummer - personeelsdienstenModel2.dienstnummer;
  });

  return personeelDienstenModel;
}
